import gql from 'graphql-tag'

export const SH_BLOCKER_GET_BLOCKING_USER_SIGN_NOW_LINK = gql`
  query GetBlockingUserSignNowLink($id: String!) {
    getBlockingUserSignNowLink(id: $id)
  }
`
